import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
import EditIcon from '@mui/icons-material/Edit'
import { UpdateParameterApplicationInstance } from '../../../../app/services/eAuthz/UpdateParameterApplicationInstance'
import { useDispatch, useSelector } from 'react-redux'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { AddParameterApplicationInstance } from '../../../../app/services/eAuthz/AddParameterApplicationInstanceEAuthz'
// import { useParams } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  minHeight: 280,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const EditParam = ({ param, refresh, parameterData }) => {
  const classes = useStyles()
  const [openModal, setopenModal] = useState(false)
  const [value, setvalue] = useState(parameterData?.parameter_num_value ? parseInt(parameterData?.parameter_num_value) : '')

  const {
    applicationInstanceId,
  } = useSelector((state) => state.adminAccessUser)

  const [showCircularProgress, setshowCircularProgress] = useState(false)
  const handleOpen = () => {
    setopenModal(true)
  }

  const dispatch = useDispatch()

  const editParameter = async () => {
    setshowCircularProgress(true)
    try {
      const body = {
        applicationInstanceId,
        appParameterCode: param.app_parameter_code,
        parameterValue: parseFloat(value),
      }
      parameterData ? await UpdateParameterApplicationInstance(body) : await AddParameterApplicationInstance(body)
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Actualización exitosa'))
      refresh()
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error en un servicio de: eAuthzAPI')
      )
    }
    setshowCircularProgress(false)
  }
  return (
    <>
      <EditIcon
        sx={{
          color: '#6e7a76',
          '&:hover': {
            color: '#00aa92',
            cursor: 'pointer'
          }
        }}
        onClick={handleOpen}
      />
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setopenModal(false)}
            />
          </div>

          <div>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Editar la{' '}
              {param.app_parameter_desc
                ? '"' + param.app_parameter_desc + '"'
                : ''}
            </Typography>
          </div>
          <div
            style={{ display: 'flex', alignItems: 'center', marginTop: '5%' }}
          >
            <Typography
              sx={{
                color: '#263057',
                fontFamily: 'Roboto'
              }}
            >
              Ingrese el nuevo valor del tope:
            </Typography>
            <input
              type="number"
              style={{ width: '30%', marginLeft: '2%' }}
              value={value}
              onChange={(e) => setvalue(e.target.value)}
            />
          </div>
          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              editParameter={editParameter}
            />

            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({ showCircularProgress, editParameter }) {
  const classes = useStyles()

  return (
    <button className={classes.confirmButton}>
      {showCircularProgress
        ? (
          <CircularProgress size="1.5rem" color="inherit" />
        )
        : (
          <Typography
            onClick={editParameter}
            className={classes.confirmButtonTypography}
            variant="contained"
          >
            Editar
          </Typography>
        )}
    </button>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
